import { Box, Card, CardContent, CardMedia, Link, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import ActivationConfirmationImg from '../images/activation-confirmation.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import { Helmet } from 'react-helmet';

const ActivationConfirmation = (): JSX.Element => {
  const { t } = useTranslation('component');
  const redirectUrl = 'http://www.familiprix.com/';

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.replace(redirectUrl) + (i18n.resolvedLanguage ?? '');
    }, 3000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.ActivationConfirmationTitle')}</title>
        <meta name="description" content={t('MetaTag.ActivationConfirmationDescription').toString()} />
      </Helmet>
      <Box
        sx={{
          minHeight: { xs: '0', md: '75vh' },
          width: { xs: 'none', md: 562 },
          padding: { xs: '16px 0 16px', md: '56px 0 56px' },
          margin: { xs: '0', md: '0 auto' },
        }}>
        <Card>
          <CardMedia component="img" image={ActivationConfirmationImg} />
          <CardContent sx={{ textAlign: 'center', mx: 6, my: 2 }}>
            <Typography display="block" variant="h1">
              {t('ActivationConfirmation.congratulation')}
            </Typography>
            <Typography display="block" variant="h1" sx={{ my: 2 }}>
              {t('ActivationConfirmation.message')}
            </Typography>
            <Box>
              <Typography display="inline">{t('ActivationConfirmation.finalInfo')}</Typography>
              <Link href={redirectUrl} underline="always">
                {redirectUrl}.
              </Link>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default ActivationConfirmation;
